import React from "react";
import { Button } from "reactstrap";
import whiteCrossIcon from "../../../../assets/images/buttons/whiteCrossIcon.svg";
import blackCrossIcon from "../../../../assets/images/buttons/blackCrossIcon.svg";
import disabledCrossIcon from "../../../../assets/images/buttons/disabledCrossIcon.svg";
import "./Icon.scss"; // Use a common SCSS file for styling

const Icon = ({
  color,
  onClick,
  disabled,
  buttonType, // New prop to handle button type (e.g., "secondary", "ghost","primary")
  size, //regular and small
  image,
  style, // New prop for custom styles
  ...rest
}) => {
  const renderIcon = () => {
    const icon = disabled
      ? disabledCrossIcon
      : buttonType == "primary"
      ? whiteCrossIcon
      : blackCrossIcon;
    //const marginRight = iconPosition === "left" ? { marginRight: "8px" } : {};
    //const marginLeft = iconPosition === "right" ? { marginLeft: "8px" } : {};
    const width = size == "small" ? { width: "16px" } : {};
    const height = size == "small" ? { height: "16px" } : {};
    return (
      <img
        src={image || icon}
        style={{
          ...width,
          ...height,
          ...style, // Merge custom styles
        }}
        alt="Icon"
      />
    );
  };
  return (
    <Button
      //className={`genericButton ${buttonType}`}
      className={`${
        size == "regular"
          ? buttonType == "primary"
            ? "regularPrimaryCrossIcon"
            : buttonType == "secondary"
            ? "regularSecondaryCrossIcon"
            : "regularGhostCrossIcon"
          : size == "small"
          ? buttonType == "primary"
            ? "smallPrimaryCrossIcon"
            : buttonType == "secondary"
            ? "smallSecondaryCrossIcon"
            : "smallGhostCrossIcon"
          : ""
      }`} // Apply a common class for styling
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {renderIcon()}
    </Button>
  );
};

export default Icon;
